import api from './api.js';

export const primarySubscriberRolesAPI = {
  // Get all roles for the primary subscriber
  getRoles: (params = {}) => api.get('/api/primary-subscriber-roles', { params }),

  // Get role statistics
  getRoleStats: () => api.get('/api/primary-subscriber-roles/stats'),

  // Get available permissions
  getAvailablePermissions: () => api.get('/api/primary-subscriber-roles/permissions'),

  // Get single role
  getRole: (roleId) => api.get(`/api/primary-subscriber-roles/${roleId}`),

  // Create new role
  createRole: (roleData) => api.post('/api/primary-subscriber-roles', roleData),

  // Update role
  updateRole: (roleId, roleData) => api.put(`/api/primary-subscriber-roles/${roleId}`, roleData),

  // Delete role
  deleteRole: (roleId) => api.delete(`/api/primary-subscriber-roles/${roleId}`),

  // Assign role to sub-account
  assignRoleToSubAccount: (roleId, subAccountId) => api.post('/api/primary-subscriber-roles/assign', { roleId, subAccountId }),

  // Remove role from sub-account
  removeRoleFromSubAccount: (subAccountId) => api.delete(`/api/primary-subscriber-roles/assign/${subAccountId}`),

  // Get pending role approval requests
  getPendingRoleApprovals: () => api.get('/api/primary-subscriber-roles/approval-requests/pending'),

  // Get role approval history
  getRoleApprovalHistory: (params = {}) => api.get('/api/primary-subscriber-roles/approval-requests/history', { params })
};


